module.exports = __webpack_public_path__ + "static/media/item_sli_filter_des.808fe052.png";